import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants
import { Constants }         from '../../constants/Constants';

//components
import {ChangePasswordComponent} from '../../components/Security/ChangePassword.component';

@Component({
  selector: 'my-resetpassword',
  templateUrl: './ResetPassword.component.html'
})
export class ResetPasswordComponent implements OnInit {

    public displayDialog: boolean;

    @ViewChild(ChangePasswordComponent) changePasswordComponent: ChangePasswordComponent;

    constructor() 
    { 

    }


    ngOnInit(): void {
        
    }

    onHide(){
        this.displayDialog = false;
    }

}